export default "__VITE_ASSET__qoUEGSyJ__"